import axios from 'axios';
import { BASE_URL } from './api';


export async function createClientWorkflowStep(token, data) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/client_workflow_steps/create_client_workflow_step/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function createMultipleClientWorkflowSteps(token, data) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/client_workflow_steps/create_multiple_client_workflow_steps/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function updateClientWorkflowStep(token, data, clientWorkflowStepId) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/client_workflow_steps/${clientWorkflowStepId}/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function deleteClientWorkflowStep(token, clientWorkflowStepId) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/client_workflow_steps/${clientWorkflowStepId}/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}
